/* @luxottica/vm-catalogue v2.1.120 */
import { RemoteLogConfig } from '@luxottica/vm-remotelog';
import { PureComponent, createElement, Component } from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';

const name = "@luxottica/vm-catalogue";
const version = "2.1.120";

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "@charset \"UTF-8\";\n\n.Catalog-module_catalog__3ZCBH {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    flex-wrap: nowrap;\n    justify-content: baseline;\n}";
var styles = {"catalog":"Catalog-module_catalog__3ZCBH"};
styleInject(css);

var css$1 = "@charset \"UTF-8\";\n\n.CatalogElement-module_catalogTile__1ugiV {\n    background: white;\n    flex-shrink: 0;\n    height: 100%;\n}\n\n.CatalogElement-module_catalogButtonBase__2ZGnV {\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n}\n\n.CatalogElement-module_catalogButtonBase__2ZGnV:focus,\n.CatalogElement-module_catalogButtonBase__2ZGnV.CatalogElement-module_selected__3A-AH {\n  outline: none;\n  box-shadow:inset 0px 0px 0px 6px rgba(51, 208, 255, 0.5);\n}\n\n.CatalogElement-module_catalogButtonBase__2ZGnV:active {\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);\n    transform: scale(0.9);\n    opacity: 1;\n}\n\n.CatalogElement-module_catalogImgContainer__3tITR {\n    position: absolute;\n    top: 0;\n    height: 65%;\n    margin-top: 6px;\n}\n\n.CatalogElement-module_catalogGlassesImg__2BXKk {\n    height: 100%;\n    overflow: hidden;\n}\n\n.CatalogElement-module_catalogTextContainer__Nff33 {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    margin-bottom: 6px;\n}\n\n.CatalogElement-module_catalogLabelText__2vAq0 {\n    font-family: Roboto;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: black;\n}\n\n.CatalogElement-module_catalogLabelText__2vAq0:hover {\n    overflow: visible;\n}\n\n.CatalogElement-module_selectionBorder__1pllh {\n    position: absolute;\n    bottom: 0;\n    height: 3px;\n    border-top: none;\n    width: 100%;\n    background: #33D0FF;\n    box-sizing: border-box;\n}";
var styles$1 = {"catalogTile":"CatalogElement-module_catalogTile__1ugiV","catalogButtonBase":"CatalogElement-module_catalogButtonBase__2ZGnV","selected":"CatalogElement-module_selected__3A-AH","catalogImgContainer":"CatalogElement-module_catalogImgContainer__3tITR","catalogGlassesImg":"CatalogElement-module_catalogGlassesImg__2BXKk","catalogTextContainer":"CatalogElement-module_catalogTextContainer__Nff33","catalogLabelText":"CatalogElement-module_catalogLabelText__2vAq0","selectionBorder":"CatalogElement-module_selectionBorder__1pllh"};
styleInject(css$1);

class CatalogElement extends PureComponent {
    render() {
        return (createElement("li", { className: styles$1.catalogTile, style: { width: `${this.props.width}px` } },
            createElement(ButtonBase, { className: `${styles$1.catalogButtonBase} ${this.props.selected ? styles$1.selected : ""}`, onClick: () => this.onClick() },
                createElement("div", { className: `${styles$1.catalogImgContainer}` },
                    createElement("img", { src: this.props.item.thumbnailLink, alt: `Image displaying ${this.props.item.label}`, className: `${styles$1.catalogGlassesImg} catalogImage` })),
                createElement("div", { className: `${styles$1.catalogTextContainer}` },
                    createElement("div", { className: `${styles$1.catalogLabelText} catalogLabel`, style: { width: `${this.props.width}px` } }, this.props.item.label),
                    (typeof (this.props.item.subtitle) !== "undefined") &&
                        createElement("div", { className: `${styles$1.catalogLabelText} ${styles$1.catalogSubtitleText} catalogLabel catalogSubtitle`, style: { width: `${this.props.width}px` } }, this.props.item.subtitle)),
                createElement("span", { className: `${styles$1.selectionBorder} catalogSelectionBorder` }))));
    }
    onClick() {
        // tslint:disable-next-line:no-unused-expression
        this.props.onClick && this.props.onClick(this.props.item.upc);
    }
}

const logger = RemoteLogConfig.getInstance().getLoggerInfo(name, version, "VirtualMirror");
class Catalog extends Component {
    constructor(props) {
        super(props);
        this.catalogDiv = null;
        this.updateSize = () => {
            if (this.catalogDiv) {
                this.setState({
                    catalogHeight: this.catalogDiv.clientHeight,
                });
            }
        };
        this.state = {
            catalogHeight: 100,
            selectedUpc: (props.selectedUpc) ? props.selectedUpc : undefined,
        };
    }
    componentDidMount() {
        window.addEventListener("resize", this.updateSize);
        this.updateSize();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateSize);
    }
    render() {
        return (createElement("ul", { className: styles.catalog, ref: (divElement) => this.catalogDiv = divElement }, this.props.items.map((item) => {
            return (createElement(CatalogElement, { key: item.upc, item: item, width: this.state.catalogHeight * 1.45, onClick: (upc) => this.upcUpdated(upc), selected: this.state.selectedUpc === item.upc }));
        })));
    }
    upcUpdated(newUpc) {
        this.setState({ selectedUpc: newUpc });
        if (this.props.onChange) {
            this.props.onChange(newUpc);
        }
        logger.info("upc updated to {}", newUpc);
    }
}

export { Catalog };
//# sourceMappingURL=vm-catalogue.js.map
